import styled from "styled-components";
 
export const RastreioContainer = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
 
export const InfoCards = styled.div`
  display: flex;
  gap: 1rem;
  div {
    width: 100%;
  }
`;

export const LinkTracking = styled.a`
  color: var(--color-text-link);
`

export const InfoCardContainer = styled.div`
  h3{
    color: var(--color-accent);
    text-align: left;
    font-size: 14px;
    font-weight: 600;
    margin: 0;
  }
  border: 1px solid var(--color-neutral-200);
  border-radius: 8px;
  overflow-x: auto;
`;

export const TitleContent = styled.div`
  padding: 12px 16px;
`
export const TrackingSummary = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 4px 16px;
  padding: 4px 16px 16px;
`

export const TrackingSummaryItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 10px 0;
  border-bottom: 1px solid var(--color-neutral-200);

  &:nth-last-child(-n+3) {
    border-bottom: none;
  }
`

export const TrackingSummaryLabel = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text-secondary);
  letter-spacing: 0.3px;
`

export const TrackingSummaryValue = styled.span`
  font-size: 12px;
  font-weight: 400;
  color: var(--color-text);
`

export const JadlogTable = styled.table`
  width: 100%;
  border-collapse: collapse;

  th, td {
    padding: 10px 12px;
    text-align: left;
    white-space: nowrap;
  }
  th {
    background-color: #F8F9F9;
    color: var(--color-text-secondary);
    font-size: 12px;
    font-weight: 600;
  }
  td {
    color: var(--color-text);
    font-size: 14px;
    font-weight: 400;
  }
  tbody tr:nth-child(even) {
    background-color: #F8F9F9;
  }
  tbody tr:nth-child(odd) {
    background-color: var(--color-bg);
  }
`

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  th, td {
    padding: 8px;
    text-align: left;
  }
  th{
    background-color: #F8F9F9;
    color: var(--color-text-secondary);
    font-size: 12px;
    font-weight: 600;
  }

  td{
    line-break: anywhere;
    color: var(--color-text);
    font-size: 14px;
    font-weight: 400;
  }

  tbody tr:nth-child(even) {
    background-color: #F8F9F9;
  }
  tbody tr:nth-child(odd) {
     background-color: var(--color-bg);
  }

  th:nth-child(1), td:nth-child(1) {
    min-width: 150px;
    width: 150px;
  }

  th:nth-child(2), td:nth-child(2) {
    min-width: 200px;
    width: 200px;
  }

  th:nth-child(3), td:nth-child(3) {
    width: 100%;
  }
`;

